import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EditTeamMemberPersonalDetailsModalContent } from './personalDetailsContent';
import { RoleAndAccessContentModalContent } from './roleAndAccessContent';
import { ModalWithSidebar, Icon, BackdropLoader } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
// import { useStore } from 'src/stores';

export const EditTeamMemberV2Modal = observer(_ref => {
  let customTrigger = _ref.customTrigger,
    data = _ref.data,
    handleTriggerShowModal = _ref.handleTriggerShowModal,
    handleShowModal = _ref.handleShowModal,
    triggerRefresh = _ref.triggerRefresh;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  // NOTE: Edit team member

  const modalTabs = [{
    label: 'Personal details',
    name: 'details'
  }, {
    label: 'Role and Access',
    name: 'access'
  }];
  const _useState = useState('details'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalIsOpen = _useState6[0],
    setModalIsOpen = _useState6[1];
  const handleOpenModal = () => {
    setModalIsOpen(true);
  };
  const handleEditModalSuccess = () => {
    setModalIsOpen(false);
  };
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "action",
    onClick: () => {},
    'custom-attribute': '288-edit-teammember-modal-v2'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('team_page.edit_team_member'));
  useEffect(() => {
    if (handleTriggerShowModal) {
      handleOpenModal();
      handleShowModal(false);
    }
    handleTabChange(undefined, 'details');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleTriggerShowModal]);
  return /*#__PURE__*/React.createElement(ModalWithSidebar, {
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger,
    isOpen: modalIsOpen,
    handleClose: () => setModalIsOpen(false) // external control
    ,
    tabs: modalTabs,
    handleTabChange: handleTabChange // external control
    ,
    selectedTab: selectedTab // external control
    ,
    title: t('team_page.edit_team_member'),
    subTitle: (data === null || data === void 0 ? void 0 : data.email) || (data === null || data === void 0 ? void 0 : data.newEmail),
    noFooter: true,
    noInnerFooter: true,
    noPadding: true
  }, selectedTab === modalTabs[0].name && /*#__PURE__*/React.createElement(EditTeamMemberPersonalDetailsModalContent, {
    dataMember: data,
    handleEditModalSuccess: handleEditModalSuccess,
    handleModalClose: () => setModalIsOpen(false),
    setIsLoading: setIsLoading,
    triggerRefresh: triggerRefresh
  }), selectedTab === modalTabs[1].name && /*#__PURE__*/React.createElement(RoleAndAccessContentModalContent, {
    dataMember: data,
    handleEditModalSuccess: handleEditModalSuccess,
    handleModalClose: () => setModalIsOpen(false),
    setIsLoading: setIsLoading,
    triggerRefresh: triggerRefresh
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});